import ActivityEditorClasses from "../CreateQuizPage/ActivityEditor.module.css";
import classes from "./ReleaseActivityPage.module.css";
import {LatexHTMLInline, LatexInline} from "../../components/Tiptap/latexParser";
import {isGeneralSA, questionCodeToName, questionCodeToSVG} from "../../utils/questionUtils";
import {
    BLANK_REGEX,
    BLANK_REGEX_NEW,
    BLANK_REGEX_WRAPPED,
    BLANK_REGEX_WRAPPED_NEW,
    POLL_SHARE_MODE,
    QUESTION_TYPES,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import {ReactComponent as ArrowDown} from "../../images/YuJa_arrow_down_icon.svg";
import {ReactComponent as ArrowUp} from "../../images/YuJa_arrow_up_icon.svg";
import {ReactComponent as POINTS_ICON} from "../../images/weightage_purple.svg"
import {ReactComponent as TIME_LIMIT_ICON} from "../../images/time_limit_purple.svg"
import {ReactComponent as COMPLETED_ICON} from "./images/completed_icon.svg"
import { ReactComponent as NoResultIllustration } from "../../images/notGradedAttendance.svg";

import React, {Fragment, useEffect, useState} from "react";
import reactStringReplace from "react-string-replace";
import ImageViewer from "../JoinQuizPage/ImageViewer";
import ClickableImageNew from "../../questions/CI/ClickableImageNew";
import responseClasses from "../JoinQuizPage/ClassResult.module.css";
import ViewLiveRespCountChart from "./ViewLiveRespCountChart";
import ViewLiveRespRK from "./ViewLiveRespRK";
import WordCloudResult from "../JoinQuizPage/WordCloudResult";
import ViewLiveRespMH from "./ViewLiveRespMH";
import ViewLiveRespOE from "./ViewLiveRespOE";
import {
    getQuestionCorrectnessPoints,
    getQuestionParticipationPoints,
    getQuestionWeightage,
    isManualGradeQue,
    questionHasCorrectness,
    questionHasWeightage,
    getSafeURL
} from "../../utils/helpers";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import parse from "html-react-parser";
import { Accordion } from '@base-ui/react/accordion';
import YuJaSwitch from "../../components/standardization/YuJaSwitch";

export default function ViewQuestionCard({
                                             poll,
                                             currentQuestionNo,
                                             openedQuestionNo,
                                             question,
                                             responseCountData,
                                             reactionCountData,
                                             localState,
}) {
    const { t } = useTranslation();
    const {serialNo, queTitle, questionType, weightage, timeLimit, shareCount, hasBlankRestriction=true} = question;
    const SHARE_STATUS_ENUM = {UNSHARED: "UNSHARED", SHARING: "SHARING", SHARED: "SHARED"}
    const [showAnswer, setShowAnswer] = useState(false);
    const [shareStatus, setShareStatus] = useState(SHARE_STATUS_ENUM.UNSHARED);

    let liveResponses = responseCountData[serialNo - 1];


    let regex = new RegExp("", "g");

    if (questionType === QUESTION_TYPES.FITB.name) {
        let blankNameArr = Object.keys(question.correctAnswers).map(str => `\\(${str}\\)`);
        if (!!weightage) {
            regex = new RegExp(`(${blankNameArr.join("|")})`, "g");
        } else {
            regex = hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX
        }

    }




    const renderAllCorrectOptions = (blankName) => {
        if (!question.correctAnswers.hasOwnProperty(blankName) || !question.correctAnswers[blankName].length) {
            return "";
        }


        if (question.correctAnswers[blankName].length === 1) {
            return question.correctAnswers[blankName];
        }

        let allOpts = "";
        for(let element of question.correctAnswers[blankName]) {
            if(allOpts !== "") {
                allOpts += " / " + element;
            }
            else {
                allOpts += element;
            }
        }
        return allOpts;
    };

    let reactionData = !!reactionCountData[serialNo - 1] ? reactionCountData[serialNo - 1] : {thumbUp: 0, thumbDown: 0};

    useEffect(() => {
        if (poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL) {
            if (localState === "GET_READY_ALL" || localState === "SHARED_ALL") {
                setShareStatus(SHARE_STATUS_ENUM.SHARING);
            } else if (!!shareCount) {
                setShareStatus(SHARE_STATUS_ENUM.SHARED);
            } else {
                setShareStatus(SHARE_STATUS_ENUM.UNSHARED);
            }
        } else if (poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE) {
            const currentTime = new Date();
            if (localState === "SHARED_ALL") {
                setShareStatus(SHARE_STATUS_ENUM.SHARING);
            } else if (localState === "TIMEUP_ALL" || new Date(poll.endTime) < currentTime) {
                setShareStatus(SHARE_STATUS_ENUM.SHARED);
            } else {
                setShareStatus(SHARE_STATUS_ENUM.UNSHARED);
            }

        } else if (poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH) {
            if (currentQuestionNo === serialNo) {
                if (localState === "GET_READY" || localState === "SHARED") {
                    setShareStatus(SHARE_STATUS_ENUM.SHARING);
                } else if (!!shareCount) {
                    setShareStatus(SHARE_STATUS_ENUM.SHARED);
                } else {
                    setShareStatus(SHARE_STATUS_ENUM.UNSHARED);
                }
            } else {
                if (!!shareCount) {
                    setShareStatus(SHARE_STATUS_ENUM.SHARED);
                } else {
                    setShareStatus(SHARE_STATUS_ENUM.UNSHARED);
                }
            }
        } else {
            setShareStatus(SHARE_STATUS_ENUM.UNSHARED);
        }
    }, [shareCount, localState, currentQuestionNo, poll]);





    return (
        <Accordion.Item
            value={serialNo}
            className={`${classes.questionCard} ${currentQuestionNo === serialNo ? classes.active : ""}`}
        >

            <Accordion.Header
                className={classes.questionCardHeader}
                style={{flexWrap: "wrap"}}
            >
                <Accordion.Trigger
                    className={classes.row}
                    style={{gap: 10, flex: 1, minWidth: 250, marginRight: 20}}
                >

                    {openedQuestionNo === serialNo ?
                        <ArrowUp style={{flexShrink: 0}}/> :
                        <ArrowDown style={{flexShrink: 0}}/>
                    }
                    <span className={`${classes.questionIndexBox} ${shareStatus === SHARE_STATUS_ENUM.SHARED ? classes.completed : ""}`}>
                        {serialNo}
                    </span>
                    <span style={{
                        flex: 1,
                        minWidth: 0,
                        fontWeight: "500",
                        color: "#000",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "left"
                    }}>
                        {questionType === QUESTION_TYPES.FITB.name &&
                            reactStringReplace(queTitle, regex, (blank, i) => {
                                return <Fragment key={i}>{"______"}</Fragment>;
                            })
                        }

                        {questionType !== QUESTION_TYPES.FITB.name &&
                            <LatexInline>{queTitle}</LatexInline>
                        }

                    </span>

                    {shareStatus === SHARE_STATUS_ENUM.SHARED &&
                        <span className={`${classes.completedText} ${classes.row}`} style={{gap: 5}}>
                            <COMPLETED_ICON/>
                            {t("questionBuilder.completeText")}
                        </span>
                    }
                </Accordion.Trigger>

                {(shareStatus !== SHARE_STATUS_ENUM.SHARED || openedQuestionNo === serialNo) &&
                    <div
                        className={classes.row}
                        style={{width: shareStatus === SHARE_STATUS_ENUM.SHARED ? "100%" : undefined, flexWrap: "wrap", rowGap: 8}}
                    >


                        <span className={classes.iconWrapper} style={{marginRight: 7}}>
                            {questionCodeToSVG(questionType, true, 16)}
                        </span>
                        <span>
                            {questionCodeToName(questionType)}
                        </span>

                        <div className={classes.rowSeparator}/>
                        <YuJaTooltip
                            disableTab={true}
                            disabled={!getQuestionParticipationPoints(question)}
                            text={parse(
                                `<span>
                                            ${getQuestionCorrectnessPoints(question)} ${t("questionBuilder.correctnessPointsLabel")}</br> 
                                            ${getQuestionParticipationPoints(question)} ${t("questionBuilder.participationPointsLabel")}</span>`
                            )}
                        >
                            <div className={classes.row}>
                                <span className={classes.iconWrapper} style={{marginRight: 7}}>
                                    <POINTS_ICON/>
                                </span>
                                <span>
                                    {questionHasWeightage(question)
                                        ? `${getQuestionWeightage(question)} ${t("poll.pointsText")}`
                                        : t("poll.ungradedText")
                                    }
                                </span>
                            </div>
                        </YuJaTooltip>


                        {![POLL_SHARE_MODE.SHARE_ALL, POLL_SHARE_MODE.SCHEDULE].includes(poll.pollShareMode) &&
                            <>
                                <div className={classes.rowSeparator}/>
                                <span className={classes.iconWrapper} style={{marginRight: 7}}>
                                    <TIME_LIMIT_ICON/>
                                </span>
                                <span>
                                    {!!timeLimit ? `${timeLimit}${t("poll.countdownSuffix")}` : t("gradebook.unlimitedText")}
                                </span>
                            </>
                        }


                        {openedQuestionNo === serialNo &&
                            <>
                                <div className={classes.rowSeparator}/>

                                <span className={`${classes.thumbUpIcon} ${classes.nonHover} `} style={{marginRight: 3}}/>
                                <span style={{fontSize: 15, fontWeight: 500, color: "#4D4D4D"}}> {reactionData["thumbUp"]} </span>
                                <div style={{width: 7}}/>
                                <span className={`${classes.thumbDownIcon} ${classes.nonHover}`} style={{marginRight: 3}}/>
                                <div style={{fontSize: 15, fontWeight: 500, color: "#4D4D4D"}}> {reactionData["thumbDown"]} </div>

                                {questionHasCorrectness(question) && !isManualGradeQue(true, questionType) &&
                                    <>
                                        <div className={classes.rowSeparator}/>
                                        <span
                                            className={classes.row}
                                            style={{gap: 5}}
                                            onClick={e => {
                                                e.stopPropagation();
                                                setShowAnswer(!showAnswer);
                                            }}
                                        >
                                            <span>{t("questionBuilder.showCorrectAnswerTitle")}</span>
                                            <YuJaSwitch
                                                label={false}
                                                aria-label={t("questionBuilder.showCorrectAnswerTitle")}
                                                checked={showAnswer}
                                                onChange={checked => setShowAnswer(checked)}
                                            />
                                            {/*<YuJaToggle*/}
                                            {/*    label={false}*/}
                                            {/*    toggled={showAnswer}*/}
                                            {/*    onClick={() => {*/}
                                            {/*    }}*/}
                                            {/*/>*/}
                                        </span>
                                    </>

                                }


                            </>
                        }

                    </div>
                }
            </Accordion.Header>


            <Accordion.Panel className={classes.questionCardBody}>
                {questionType === QUESTION_TYPES.FITB.name &&
                    <span className={classes.row} style={{flexWrap: "wrap", gap: 0}}>
                       {queTitle.split(question.hasBlankRestriction ? BLANK_REGEX_WRAPPED_NEW : BLANK_REGEX_WRAPPED).map((str, i) => { // /(\(.*?\))/g
                           let re = new RegExp(question.hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX); // /\([^\(\)]+\)/g
                           if (!re.test(str)) {
                               const oneLine = str.replace(/[\r\n]/g, " @newLine ");
                               const wordArr = oneLine ? oneLine.split(" ") : [];
                               return (
                                   <Fragment key={i}>
                                       {wordArr.map((s, idx) => (
                                           <Fragment key={idx}>
                                               {s === '@newLine' &&
                                                   <div style={{width: "100%"}}></div>
                                               }
                                               {!!s && s !== '@newLine' &&
                                                   <div style={{marginRight: "5px"}}>{s}</div>
                                               }
                                           </Fragment>
                                       ))}
                                   </Fragment>
                               );
                           } else {
                               // const id = currIndex;
                               let blankName = str.substring(1, str.length - 1);

                               return (
                                   <div key={i} className={`${classes.FITBBox} ${showAnswer ? classes.correct : ""}`}>
                                       {!!showAnswer &&
                                           renderAllCorrectOptions(blankName)
                                       }
                                   </div>
                               );
                           }
                       })}

                   </span>
                }

                {questionType !== QUESTION_TYPES.FITB.name &&
                    <LatexHTMLInline>{queTitle}</LatexHTMLInline>
                }

                <div style={{height: 20}}/>


                {questionType !== QUESTION_TYPES.CI.name && !!question.imageURL && !question.directLinkEvp &&
                    <ImageViewer
                        width={360}
                        height={170}
                        alt={question.imageAlt}
                        imageURL={question.imageURL}
                        styles={{alignSelf: "center"}}
                    />
                }
                {!question.imageURL && !!getSafeURL(question.directLinkEvp) &&
                    <iframe allowFullScreen style={{width: 360, height: 240, alignSelf: "center"}}
                            src={getSafeURL(question.directLinkEvp)}/>
                }

                {questionType === QUESTION_TYPES.CI.name &&
                    <div className={ActivityEditorClasses.questionMediaViewerWrapper} style={{width: 360}}>
                        <div className={ActivityEditorClasses.questionMediaViewer}>
                            <ClickableImageNew
                                selectedQuestion={question}
                                disableDrag={true}
                                showOptionArea={true}
                            />
                        </div>

                    </div>


                }


                <div style={{height: 20}}/>
                {!!liveResponses && (questionType === QUESTION_TYPES.MCSS.name
                        || questionType === QUESTION_TYPES.TF.name
                        || questionType === QUESTION_TYPES.CI.name)
                    &&
                    <ViewLiveRespCountChart
                        chartData={liveResponses}
                        showCorrectAnswer={showAnswer}
                        question={question}
                        isExpanded={openedQuestionNo === serialNo}
                        isShared={shareStatus === SHARE_STATUS_ENUM.SHARING || shareStatus === SHARE_STATUS_ENUM.SHARED}
                    />
                }

                {!!liveResponses && isGeneralSA(questionType) &&
                    <div className={classes.column} style={{gap: 10}} >
                        {!!liveResponses && liveResponses.length > 0 && liveResponses.map((response, index) =>
                            <div key={index}  className={responseClasses.allResponseCard}>
                                {response}
                            </div>
                        )}

                        {(!liveResponses || !liveResponses.length) &&
                            <>
                                <NoResultIllustration width={130} height={71} style={{alignSelf: "center", marginTop: 20}}/>
                                <span style={{fontSize: 16, lineHeight: "19px", fontWeight: 600, alignSelf: "center"}}>
                                    {t("response.noResponsesYet")}
                                </span>
                                <span style={{fontSize: 14, lineHeight: "16px", fontWeight: 400, alignSelf: "center"}}>
                                  {t("poll.saNoResponseExplainReleasePage")}
                              </span>
                            </>
                        }
                    </div>
                }

                {!!liveResponses && questionType === QUESTION_TYPES.FITB.name &&
                    <div className={classes.column} style={{gap: 10}}>
                        {liveResponses.map((response, index) =>
                            <div key={index} className={responseClasses.allResponseCard}>
                                <div>
                                    {Object.keys(response).map((key, idx) =>
                                        <div key={idx} >- {response[key]}</div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                }


                {!!liveResponses && questionType === QUESTION_TYPES.WC.name &&
                    <div
                        style={{
                            alignSelf: "center",
                            width: "min(800px, 100%)",
                            height: 300,
                            backgroundColor: "#F6F6F6E6",
                            border:  "1px solid #E6E6E6",
                            borderRadius: 4,
                            display: "flex", alignItems: "center", justifyContent: "center"
                        }}
                    >
                        <WordCloudResult data={liveResponses} />
                    </div>
                }

                {!!liveResponses && questionType === QUESTION_TYPES.RK.name &&
                    <ViewLiveRespRK
                        question={question}
                        chartData={liveResponses}
                        isExpanded={openedQuestionNo === serialNo}
                    />
                }

                {!!liveResponses && questionType === QUESTION_TYPES.MH.name &&
                    <Accordion.Root multiple className={classes.column} style={{gap: 10}} >
                        {question.correctAnswers.filter(i => i.length > 1).map((key, index) =>
                            <ViewLiveRespMH
                                key={index}
                                correctAnswers={question.correctAnswers}
                                premise={key[0]}
                                premiseIdx={index}
                                data={liveResponses[key[0]]}
                                shouldShowCorrect={showAnswer}
                                isShared={shareStatus === SHARE_STATUS_ENUM.SHARING || shareStatus === SHARE_STATUS_ENUM.SHARED}
                            />
                        )}
                    </Accordion.Root>
                }

                {!!liveResponses && questionType === QUESTION_TYPES.OE.name &&
                    <ViewLiveRespOE originalData={liveResponses}/>
                }
            </Accordion.Panel>
        </Accordion.Item>
    );
}